import React  , {useContext , useEffect , useState} from 'react'
import CartContext from '../../../../context/cart_context'
import RestaurentContext from '../../../../context/rest_context';
import RestaurentModel from '../../../../models/Restaurent_model';
import {useLocation , useNavigate} from "react-router-dom";


import "../../../restaurent-page/components/alert-comp/restaurentAlert.css"
import { LoadingSpinner } from '../../../../components/mini-components/mini-components';
import { get, ref } from 'firebase/database';
import { db } from '../../../../config/firebase_config';

const CheckoutAlert = () => {
  
const {  selectedRest , resetCart} = useContext(CartContext);
const {tappedStore, setTappedStore} = useContext(RestaurentContext);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const storeID = queryParams.get('storeID');


  const [showAlert, setShowAlert] = useState(false);

useEffect(() => {
    
  const getRestData = async() => {
    const dbRestRef = ref(db, `RestaurantMenu/${storeID}`);
      const restSnap = await get(dbRestRef);
      if (restSnap.exists()) {
        const data = restSnap.val();
        console.log( "<--- rest comp data  --->" , data , storeID);
        const restItem = RestaurentModel.fromJson( storeID , data);
        setTappedStore(restItem);
      }
  }

  if(storeID !==  selectedRest.dbID){
    setShowAlert(true) ;
    getRestData();
}

}, [])



  return (
    showAlert &&
    <div className='alert-box-bg'>
        <div className='alert-box-container' >
          {
            tappedStore == null 
            ? <LoadingSpinner/>
            :
                <>
                <h3>Replace Cart Item ?</h3>
                <p>Your cart Contains dishes from <span>{selectedRest.name}</span> . </p>
                <p>Do you want to discard the selection and add dishes from <span> {tappedStore.name} </span> </p>
                <div className='select-options'>
                    <button className='select-no' onClick={() => {
                      setShowAlert(false) ;
                    } } >No</button>
                    <button  onClick={() => {
                      setShowAlert(false) ;
                      resetCart();
                      navigate(`/restaurent?${queryParams}` ,{ replace: true } );
                    }} >Yes</button>
              </div>
            </>    
            
          }
            
        </div>
    </div>
  )
}

export default CheckoutAlert
